import axios from 'axios';

// Configure Axios global defaults for API base and credentials.
// CRA injects REACT_APP_* at build time.
const apiBase = process.env.REACT_APP_API_BASE || '';

if (apiBase) {
  axios.defaults.baseURL = apiBase.replace(/\/$/, '');
}

// If the API uses cookies/sessions across subdomains, enable credentials
axios.defaults.withCredentials = true;

export default axios;

